import footerImages from '~/footer.json'
import illustrations from '~/illustrations.json'
import illustrationsMini from '~/illustrationsMini.json'

type GlobalImport = Record<string, string> | undefined

type ImageDimensions = { height: number; width: number }

const resolveImportGlob = async (glob?: () => Promise<GlobalImport>) => {
  if (!glob) return null

  const result = await glob()
  return result?.default || null
}

export const useAsset = () => {
  const importGlob = import.meta.glob<GlobalImport>([
    '~/assets/animations/**/*',
    '~/assets/img/illustration/**/*',
    '~/assets/img/lottery/**/*',
    '!**/style',
  ])

  const findGlobEntry = (suffix: string) => {
    const key = Object.keys(importGlob).find((k) => k.endsWith(suffix))
    return key ? importGlob[key] : undefined
  }

  const getAnimation = (name: string) => {
    const animation = findGlobEntry(`/assets/animations/${name}.svg`)
    return resolveImportGlob(animation)
  }

  const getFooterImage = (name: string) => {
    const footerImage = (footerImages as Record<string, ImageDimensions>)[name]
    if (!footerImage) return null

    return {
      height: footerImage.height,
      url: `/assets/img/footer/${name}.svg`,
      width: footerImage.width,
    }
  }

  const getIllustration = (name: string) => {
    const illustration = (illustrations as Record<string, ImageDimensions>)[name]
    if (!illustration) return null

    return {
      height: illustration.height,
      src: `/assets/img/illustration/${name}.svg`,
      width: illustration.width,
    }
  }

  const getIllustrationMini = (name: string) => {
    const illustration = (illustrationsMini as Record<string, ImageDimensions>)[name]
    if (!illustration) return null

    return {
      height: illustration.height,
      src: `/assets/img/illustration-mini/${name}.svg`,
      width: illustration.width,
    }
  }

  const getLotteryHighlight = (addOnName: string) => {
    const image = findGlobEntry(`/assets/img/lottery/highlight/${addOnName.toLowerCase()}.svg`)
    return resolveImportGlob(image)
  }

  return {
    getAnimation,
    getFooterImage,
    getIllustration,
    getIllustrationMini,
    getLotteryHighlight,
  }
}
